import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { FavoriteIcon_active, FavoriteIcon_inactive } from '../icons/OurIcons';
import { REIX_BLUE } from '../../utility/constants';
import { toggleFavoriteAsync } from '../../redux/state/favoriteSlice';
import { IconButton } from './IconButton';
import { Toast } from 'primereact/toast';
import { useLoginPrompt } from './LoginPromptContext';

type FavoriteButtonProps = {
  propertyId: string;
};

export const FavoriteButton = ({ propertyId }: FavoriteButtonProps) => {
  // Connect react from redux using useSelector
  const isFavorite = useSelector(
    (state: RootState) => state?.favorite?.favorites[propertyId]
  );
  // Dispatch actions because react cannot connect to redux
  const dispatch = useDispatch<AppDispatch>();
  const { isLoggedIn, promptLogin } = useLoginPrompt();
  const status = isFavorite ? true : false;
  const loading = isFavorite ? isFavorite.loading : false;
  const error = isFavorite ? isFavorite.error : null;
  const toast = useRef(null);

  const showError = () => {
    toast.current?.show({
      severity: 'error',
      summary: 'Error',
      detail: 'There was a problem favoriting this property.',
      life: 3000,
    });
  };

  useEffect(() => {
    if (error) {
      console.error(
        'There is an error in updating the favorite status. error: ',
        error
      );
      showError();
    }
  }, [error]);

  const icon = isFavorite ? (
    <FavoriteIcon_active color={REIX_BLUE} />
  ) : (
    <FavoriteIcon_inactive color={REIX_BLUE} />
  );

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!isLoggedIn) {
      promptLogin({ message: 'Sign in to save favorites.' });
      return;
    }
    dispatch(toggleFavoriteAsync({ propertyId, currentState: status }));
  };

  return (
    <>
      <Toast ref={toast} position="bottom-right" />
      <IconButton
        icon={icon}
        label="Favorite"
        onClick={onClick}
        loading={loading}
      />
    </>
  );
};
